module.exports = __webpack_public_path__ + "img/ic_service_content.2f6b0f6d.png";